import styled from "styled-components/macro";

export const DiagramLayoutContainer = styled.div``;
export const DiagramContainer = styled.div`
  width: 100%;
  height: calc(100% - 35px);
`;
export const CrumbContainer = styled.div``;
